import * as LogLevels from "../../constants/logLevels";

export default {
    log: (text, level) => {
        console.log(`%c${text}`, LogLevels.LogLevelColours[level]);
    },
    logEventTransition: (logSource, eventName, stateFrom, stateTo) => {
        console.log(
            `%c${logSource}: %c${eventName} %c| %c${stateFrom} %c-> %c${stateTo}`,
            LogLevels.LogLevelColours[LogLevels.MISC],
            LogLevels.LogLevelColours[LogLevels.WARNING],
            LogLevels.LogLevelColours[LogLevels.MISC],
            LogLevels.LogLevelColours[LogLevels.INFO],
            LogLevels.LogLevelColours[LogLevels.MISC],
            LogLevels.LogLevelColours[LogLevels.WARNING]
        );
    },
    logMachineEvent: (logSource, action, event) => {
        console.log(
            `%c${logSource}: %c${action} %c${
                event !== "" ? `-> %c${event}` : "%c"
            }`,
            LogLevels.LogLevelColours[LogLevels.MISC],
            LogLevels.LogLevelColours[LogLevels.WARNING],
            LogLevels.LogLevelColours[LogLevels.MISC],
            LogLevels.LogLevelColours[LogLevels.INFO]
        );
    },
    logSendToChild: (logSource, childName, childState, event) => {
        console.log(
            `%c${logSource} -> %c${childName} %c${
                childState !== "" ? `(${childState})` : ""
            } %c| %c${event}`,
            LogLevels.LogLevelColours[LogLevels.MISC],
            LogLevels.LogLevelColours[LogLevels.WARNING],
            LogLevels.LogLevelColours[LogLevels.INFO],
            LogLevels.LogLevelColours[LogLevels.MISC],
            LogLevels.LogLevelColours[LogLevels.WARNING]
        );
    },
};
